<template>
    <div  class="dataTable chartDataTable" >
       <div class="chart-container">
            <div class="visualization-menu">
                <div class="chart-menu chart-menu-country">
                    <span class="header">Country</span>

                    <BDropdown :text="selectedCountry ? selectedCountry : 'All'" v-if="mapFilterData.countries" variant="light" class="w-100">
                        <template v-for="(countryName, index) in mapFilterData.countries"
                                v-bind:key="'country-' + index"  rel="noopener">
                            <BDropdownItem
                                href @click.prevent="selectCountry(countryName)"
                            >
                                {{countryName}}
                            </BDropdownItem>
                        </template>
                    </BDropdown>

                </div>
                <div class="chart-menu chart-menu-state">
                    <span class="header">State</span>

                    <BDropdown :text="selectedStateCode ? getStateName(selectedStateCode, true) : 'All'" variant="light"
                        class="w-100" :disabled="!statesFilterEnabled">
                        <template v-for="(stateName, index) in mapFilterData.states"
                                v-bind:key="'country-' + index">
                            <BDropdownItem href @click.prevent="selectState(getStateName(stateName, false))" rel="noopener">
                                {{ stateName }}
                            </BDropdownItem>
                        </template>
                    </BDropdown>

                </div>
                <div class="chart-menu chart-menu-congDist">
                    <span class="header">Congressional District:</span>

                    <BDropdown :text="selectedCongDist ? selectedCongDist : 'All'" variant="light" class="w-100"
                        :disabled="!congDistData">
                        <BDropdownItem href @click.prevent="selectCongDist('All')" v-bind:key="'congDistAll0'"
                            v-if="congDistData" rel="noopener">
                            All
                        </BDropdownItem>
                        <template v-for="(stateName, index) in sortedCongDistData"
                                v-bind:key="'country-' + index">
                            <BDropdownItem href @click.prevent="selectCongDist(stateName.code)" rel="noopener">
                                {{ stateName.code }}
                            </BDropdownItem>
                        </template>
                    </BDropdown>
                </div>
                <div class="chart-menu chart-menu-projects">
                    <span class="header">Projects</span>
                    <div class="chart-header-value">
                        <template v-if="selectedCongDist && congDistData && congDistData[selectedCongDist]">
                            {{ filters.addCommas(congDistData[selectedCongDist].projects_count) }}
                        </template>
                        <template v-else-if="selectedStateCode && stateData && stateData[selectedStateCode]">
                            {{ filters.addCommas(stateData[selectedStateCode].projects_count) }}
                        </template>
                        <template v-else-if="totalProjects">
                            {{ filters.addCommas(totalProjects) }}
                        </template>
                    </div>
                </div>
                <div class="chart-menu chart-menu-funding">
                    <span class="header">Funding</span>
                    <div class="chart-header-value">
                        <template v-if="selectedCongDist && congDistData && congDistData[selectedCongDist]">
                            {{ congDistData[selectedCongDist].projects_funding_amount ? filters.formatCurrency(congDistData[selectedCongDist].projects_funding_amount) : ''}}
                        </template>
                        <template v-else-if="selectedStateCode && stateData && stateData[selectedStateCode]">
                            {{ stateData[selectedStateCode].projects_funding_amount ? filters.formatCurrency(stateData[selectedStateCode].projects_funding_amount) : '' }}
                        </template>
                        <template v-else-if="totalFunding">
                            {{ filters.formatCurrency(totalFunding)}}
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div id="map-container" class="d-none map-container">
            <div v-if="!loadingMap && mapData && mapData.length === 0" class="no-data">{{ noDataErrorMsg }}</div>     
            <div v-if="mapError" class="no-data">{{ mapError }}</div>
            <div v-show="loadingMap" class="loading loading-map">
                <div class="loader-bg"></div><span class="loader">Loading...</span>
            </div>
            <div id="map-navs">
                <div id="heatmap-box" class="nicebox heat-map show-if-heatmap" v-if="showWorldMapIcon && showUSMapIcon">
                    <div class="heatmap-circle">
                        <button @click.prevent="selectCountry('UNITED STATES')">
                            <img srcset="../../assets/icon-states-solid@2x.png 2x"
                                src="../../assets/icon-states-solid.png" alt="Back to US map" />
                            <span class="badge off">US Heatmap</span>
                        </button>
                    </div>
                </div>
                <div id="mapbar" v-if="showWorldMapIcon && showUSMapIcon"></div>
                <div id="globe-box" class="nicebox heat-map" v-if="showWorldMapIcon">
                    <div class="heatmap-circle globe">
                        <button @click.prevent="selectCountry('All')">
                            <img srcset="../../assets/icon-world-solid@2x.png 2x"
                                src="../../assets/icon-world-solid.png" alt="Back to world map" />
                            <span class="badge off">World</span>
                        </button>
                    </div>
                </div>
                <div id="stmapbar" v-if="showWorldMapIcon && showUSStateMapIcon"></div>
                <div id="state-box" class="nicebox heat-map" v-if="showWorldMapIcon && showUSStateMapIcon">
                    <div class="heatmap-circle btn-state">
                        <div id="stCircButton">
                            <button @click.prevent="selectState(selectedStateCode)">
                                <div id="stateMapCircle"></div>
                                <span id="state-name" class="badge off"></span>
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            <div id="theMap" class="map" ref="theMap"></div>
            <div class="global-tooltip" v-show="tooltipContent" v-html="tooltipContent" ref="tooltip"></div>

        </div>

        <div class="tableContainer">
            <div v-if="activeOrg" class="table-header">
                <span class="label">Organization: </span><span>{{ activeOrg }}
                    ({{ orgData[activeMarkerIndex].projects_count }} Project<template
                        v-if="orgData[activeMarkerIndex].projects_count > 1">s</template>)</span>
            </div>
            <div v-show="loadingGraphData && !mapTable.isLoading" class="loading">
                <div class="loader-bg"></div><span class="loader">Loading...</span>
            </div>
            <dataTable :table="mapTable" fromPage="maps"
                v-show="!loadSlide && graphData && graphData.results && graphData.results.length > 0" ref="dataTable" />
        </div>

    </div>

</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import globalMixins from '@/globalMixins';
import dataTable from '@/components/global/dataTable.vue';
import bus from '@/shared/event-bus.js'; 
import { toRaw } from "vue";

export default {
    name: 'maps',
    mixins: [globalMixins],
    components: {
        dataTable
    },
    props: [
        'mapTable'
    ],
    computed: {
        ...mapGetters([
            'searchMeta',
            'searchResults',
            'graphData',
            'searchCriteria',
            'editSearchCriteria',
            'searchFacetCriteria',
            'selectedPerson',
            'noDataErrorMsg',
            'externalURLs'
        ]),
        statesFilterEnabled: function () {
            if (this.mapFilterData && this.mapFilterData.countries.indexOf(this.USA) !== -1 && (this.selectedCountry === this.USA || this.selectedCountry === null || this.selectedCountry === 'All')) {
                return true;
            } else {
                return false;
            }
        },
        sortedCongDistData: function () {
            let data = toRaw(this.congDistData);
            data = _.orderBy(data, 'code', 'asc');
            return data;
        }
    },
    data: function () {
        return {
            init: false,
            mapLoadingFirstTime: true,
            serverless: false,
            USA: 'UNITED STATES',
            mapData: null,
            mapMarkers: [],
            markersWithoutLatLongCount: 0,
            countryData: null,
            stateData: null,
            congDistData: null,
            orgData: null,
            activeOrg: null,
            selectedCountry: null,
            activeCountry: null,
            selectedStateCode: null,
            selectedCongDist: null,
            activeStateCode: null,
            activeCongDist: null,
            activeMarkerIndex: null,
            mapView: 'USState',
            totalProjects: 0,
            totalFunding: 0,
            terList: ['AS', 'GU', 'MP', 'PR', 'VI'],
            markerData: {
                projects: {
                    min: 0,
                    max: 0
                },
                funding: {
                    min: 0,
                    max: 0
                }
            },
            countryCenter: {
                US: { lat: 37.09024, lng: -95.712891 }
            },
            theMap: null,
            theMapLabels: null,
            mapFilterData: {
                countries: [],
                countriesNotUS: [],
                states: [],
                districts: []
            },
            tooltipContent: null,
            heatmap: {
                visible: false,
                funding: {
                    min: 0,
                    max: 0
                },
                color: [
                    // weighted gradient
                    '#a8e8b6',
                    '#97dcb8',
                    '#5db8bb',
                    '#3ea5bd',
                    '#3ea5bd',
                    '#0081bd',
                    '#0081bd',
                    '#0067a9',
                    '#0067a9',
                    '#003885'
                ],
                congDistFunding: {

                }
            },
            mapPlotBy: 'projects_funding_amount', // or 'projects_count'
            loadSlide: false,
            chartType: 'bar',
            plotBy: 'count',
            loadingDrillDownData: false,
            selectedDrillDownRow: null,
            chartTable: {
                name: 'Visualization',
                totalCount: 0,
                columns: {
                    GroupBy: {
                        displayName: '',
                        fieldName: 'group_by',
                        rowData: false,
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        helpText: 'fieldName'
                    },
                    ProjectCount: {
                        displayName: 'Projects',
                        fieldName: 'project_count',
                        formatType: 'count',
                        sortOrder: 'asc',
                        callFunctionOnClick: true,
                        isVisible: true,
                        isSortable: true,
                        helpText: 'Projects'
                    },
                    ProjectFundingAmt: {
                        displayName: 'Total Funding',
                        fieldName: 'project_funding_amt',
                        formatType: '$',
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        helpText: 'Total Funding'
                    },
                    SubprojectCount: {
                        displayName: 'Sub Projects',
                        fieldName: 'subproject_count',
                        callFunctionOnClick: true,
                        formatType: 'count',
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        helpText: 'Sub Projects'
                    },
                    SubProjectFundingAmt: {
                        displayName: 'Sub Project Funding',
                        fieldName: 'sub_project_funding_amt',
                        formatType: '$',
                        sortOrder: 'asc',
                        isVisible: true,
                        isSortable: true,
                        helpText: 'Sub Project Funding'
                    },
                },
                totalColumns: 5,
                sortField: "project_count",
                sortOrder: 'desc',
                defaultSortField: "project_count",
                defaultSortOrder: 'desc'
            },
            loadingMap: false,
            loadingGraphData: false,
            sharedSpecs: window.sharedSpecs,
            exportTitleLines: 0,
            mapStyles: {
                color: {
                    water: '#ffffff',
                    land: '#eeeeee',
                    textProminentFill: '#000000',
                    textProminentStroke: '#ffffff',
                    textFill: '#000000',
                    textStroke: '#ffffff',
                    subtextFill: '#20558A',
                    textWaterFill: '#ffffff',
                    roads: '#dddddd'
                }
            },
            mapLayer: {
                heatmapUS: null,
                heatmapUSState: null
            },
            geoJSON: {
                heatmapUS: null
            },
            mapError: null,
            showUSStateMapIcon: false,
            showUSMapIcon: false,
            showWorldMapIcon: false,
            pageName: 'map',
            filters: window.filters,
            stateLookUp: null
        };
    },
    watch: {
        searchFacetCriteria: function (val, oldVal) {
            if (!this.selectedPerson) {
                this.addGoogleMapsScript();
            }
        },
        '$store.state.externalURLs.reporter_google_map_api_key': function (val, o) {
            let googleMapsNotAlreadyLoaded = document.getElementById('google-maps-script') === null;

            if (val && googleMapsNotAlreadyLoaded) {
                this.loadMapWithKey();
            }
        },
        '$store.state.lookup.org_states': function (val, o) {
            if (val) {
                this.stateLookUp = this.$store.state.lookup['org_states'];
            }
        }
    },
    mounted () {
        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
            this.$router.push({ path: '/' });
        }

        this.setFullscreen(true);
        this.loadingGraphData = true;

        if (!this.searchCriteria) {
            this.$parent.getSearchCriteria(this.loadData);
        } else {
            this.loadData();
        } 

        if (this.searchFacetCriteria) {
            this.addGoogleMapsScript();
        }

        this.stateLookUp = this.$store.state.lookup['org_states'];
        bus.$on('map:init', () => {
            this.initMap();
        });

        bus.$on('update:reviseSearchMap', () => {
            this.resetMapFilters();
            this.loadData();
        });

        bus.$on('set:projectNumber', (routeName) => {
            this.setProjectPageNumber(routeName);
        });
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setSearchMode',
            'setGraphData',
            'updateGraphData',
            'setGraphSettings'
        ]),
        getStateName (name, isStateCode) {
            if (name) {
                let state = null;
                if (!isStateCode) {
                    state = _.filter(this.stateLookUp, st => st.name === name);
                    if (state && state.length > 0) {
                        return state[0].value;
                    }
                } else {
                    state = _.filter(this.stateLookUp, st => st.value === name);
                    if (state && state.length > 0) {
                        return state[0].name;
                    }
                }
            }
            return 'All';
        },
        loadData () {
            bus.$emit('init:facet');

            this.getTableData();
        },
        setupMapFilterData () {
            let i,
                i2,
                mapDataLength = this.mapData.length,
                hasStates,
                countryName,
                stateName,
                facetFilters = this.$parent.searchFacetCriteria;

            this.resetMapFilterData();

            for (i = 0; i < mapDataLength; i++) {
                hasStates = this.mapData[i].states !== null;
                countryName = this.mapData[i].name;

                this.mapFilterData.countries.push(countryName);

                if (countryName !== this.USA) {
                    this.mapFilterData.countriesNotUS.push(countryName);
                }

                if (hasStates && countryName === this.USA) {
                    for (i2 = 0; i2 < this.mapData[i].states.length; i2++) {
                        stateName = this.mapData[i].states[i2].name;

                        this.mapFilterData.states.push(stateName);
                    }
                }
            }

            this.mapFilterData.countries = this.mapFilterData.countries.sort((a, b) => {
                if (a === this.USA) {
                    return -1;
                } else if (b === this.USA) {
                    return 1;
                }

                return a === b ? 0 : (a < b ? -1 : 1);
            });

            this.mapFilterData.states.sort();

            if (this.mapFilterData.countries.length !== 1) {
                this.mapFilterData.countries.unshift('All');
            } else {
                this.selectedCountry = this.mapFilterData.countries[0];
            }
            if (this.mapFilterData.states.length !== 1) {
                this.mapFilterData.states.unshift('All');
            } else {
                if (this.mapFilterData.countries.length === 1) {
                this.selectedStateCode = this.getStateName(this.mapFilterData.states[0], false);
            }
            }
            this.mapFilterData.districts.unshift('All');
        },
        resetMapFilterData () {
            this.mapFilterData.countries = [];
            this.mapFilterData.countriesNotUS = [];
            this.mapFilterData.states = [];
            this.mapFilterData.districts = [];
        },
        addGoogleMapsScript () {
            let googleMapsNotAlreadyLoaded = document.getElementById('google-maps-script') === null;          
            if (googleMapsNotAlreadyLoaded) {
                let key = this.externalURLs['reporter_google_map_api_key'];
                if (key) {
                    this.loadMapWithKey();
                }
            } else {
                let mapDisplay = this.externalURLs['reporter_map_display'];
                if (mapDisplay === 'true') {
                  document.getElementById("map-container").classList.remove("d-none");
                }
                if (this.init && !this.mapLoadingFirstTime) {
                    this.updateMap();
                } else if (!this.init) {
                    this.initMap();
                }
            }
        },
      loadMapWithKey() {        
            let mapDisplay = this.externalURLs['reporter_map_display'];       
            if (mapDisplay === 'true') {
              document.getElementById("map-container").classList.remove("d-none");
              let gmScript = document.createElement('script'),
                key = this.externalURLs['reporter_google_map_api_key'],
                version = '3.60';

              gmScript.setAttribute('id', 'google-maps-script');
              gmScript.setAttribute('src', '//maps.googleapis.com/maps/api/js?key=' + key + '&v=' + version + '&callback=initGoogleMap&loading=async');
              document.head.appendChild(gmScript);
            } else {
             let searchParam = {
                   search_id: this.$route.params.search_id,
                   facet_filters: this.$parent.searchFacetCriteria,
                   map_filters: {
                       states: [],
                       countries: [],
                       cong_dists: []
                   }
               };
            window.getMapData(searchParam, this.parseMapData, null);
          }            
        },
      initMap() {                        
            this.getCountryCenters();
            this.getMapData(this.buildMap);
            this.init = true;
        },
        buildMap () {
            this.mapError = null;
            if (!google || !google.maps) {
                this.mapError = 'Unable to load maps from Google';
                return false;
            }

            this.theMap = new google.maps.Map(this.$refs.theMap, {
                center: this.countryCenter.US,
                zoom: 4,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                gestureHandling: window.isMobile ? 'cooperative' : 'greedy',
                backgroundColor: 'none',
                styles: [
                    {
                        featureType: 'landscape',
                        elementType: 'geometry',
                        stylers: [{
                            color: this.mapStyles.color.land,
                        }]
                    },
                    {
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: this.mapStyles.color.textStroke }]
                    },
                    {
                        elementType: 'labels.text.fill',
                        stylers: [{ color: this.mapStyles.color.textFill }]
                    },
                    {
                        featureType: 'administrative.country',
                        elementType: 'labels.text.fill',
                        stylers: [{ color: this.mapStyles.color.textProminentFill }]
                    },
                    {
                        featureType: 'administrative.country',
                        elementType: 'labels.text.stroke',
                        stylers: [{ color: this.mapStyles.color.textProminentStroke }]
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'administrative.neighborhood',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'poi',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{ color: this.mapStyles.color.roads }]
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'transit',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{
                            color: this.mapStyles.color.water,
                        }]
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text',
                        stylers: [{ visibility: 'off' }]
                    }
                ]
            });

            this.setupHeatmapUS();

            let mapLoadedListener = this.theMap.addListener('idle', () => {
                this.duplicateMapLabelsOverHeatmap();
                google.maps.event.removeListener(mapLoadedListener);
            });

            this.mapLoadingFirstTime = false;
            this.loadingMap = false;
        },
        duplicateMapLabelsOverHeatmap () {
            // Create an overlay to display map labels only
            this.theMapLabels = new google.maps.StyledMapType([
                // Hide all map features by default
                {
                    stylers: [{
                        visibility: 'off'
                    }]
                }, {
                    // then turn the label feature on
                    elementType: 'labels',
                    stylers: [{ visibility: 'on' }]
                },
                {
                    elementType: 'labels.text.stroke',
                    stylers: [{ color: this.mapStyles.color.textStroke }]
                },
                {
                    elementType: 'labels.text.fill',
                    stylers: [{ color: this.mapStyles.color.textFill }]
                },
                {
                    featureType: 'poi',
                    stylers: [{ visibility: 'off' }]
                },
                {
                    featureType: 'administrative.country',
                    elementType: 'labels.text.fill',
                    stylers: [{ color: this.mapStyles.color.textProminentFill }]
                },
                {
                    featureType: 'administrative.country',
                    elementType: 'labels.text.stroke',
                    stylers: [{ color: this.mapStyles.color.textProminentStroke }]
                },
                {
                    featureType: 'administrative.neighborhood',
                    stylers: [{ visibility: 'off' }]
                },
                {
                    featureType: 'road',
                    elementType: 'labels.icon',
                    stylers: [{ visibility: 'off' }]
                },
                {
                    featureType: 'transit',
                    stylers: [{ visibility: 'off' }]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry',
                    stylers: [{ color: '#000000' }]
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text',
                    stylers: [{ visibility: 'off' }]
                }
            ], {
                name: 'Labels'
            });

            // Add to the map's overlay collection
            this.theMap.overlayMapTypes.push(this.theMapLabels);
        },
        getHeatmapShapeData (callback) {
            this.mapView = 'USState';
            window.getJSON({
                url: '/data/geo-states.json',
                callback: callback
            });
        },
        getUSHeatmapShapeData (callback) {
            this.mapView = 'congDist';
            window.getJSON({
                url: '/data/CD-parts/' + this.selectedStateCode + '.json',
                callback: callback
            });
        },
        getCountryCenters () {
            window.getJSON({
                url: '/data/geo-countries-latlng.json',
                callback: (countries) => {
                    for (let country in countries) {
                        this.countryCenter[country.toUpperCase()] = countries[country].latLng;
                    }
                }
            });
        },
        setupHeatmapUS () {
            if (!google.maps.Polygon.prototype.getBounds) {
                google.maps.Polygon.prototype.getBounds = function () {
                    var bounds = new google.maps.LatLngBounds();
                    this.getPath().forEach(function (element, index) { bounds.extend(element); });
                    return bounds;
                }
            }

            this.getHeatmapShapeData(this.buildHeatmapUS);
        },
        styleHeatmapShape (feature) {
            var stateCode = feature.getProperty("CDId") ? feature.getProperty("CDId") : feature.getProperty("ABVR"),
                stateData,
                cDistData,
                delta,
                activeCode,
                zIndex = 1,
                strokeWeight = 0.5,
                strokeColor = '#888',
                fillColor = '#ddd',
                fillOpacity = 0.75,
                colorIndex = 0,
                show = true;

            if (this.selectedStateCode) {
                activeCode = this.activeCongDist;
                stateCode = this.selectedStateCode + '-' + stateCode;
                if (this.congDistData && this.congDistData[stateCode]) {
                    cDistData = this.congDistData[stateCode][this.mapPlotBy];
                    delta = (cDistData - this.heatmap.congDistFunding.min) / (this.heatmap.funding.max - this.heatmap.congDistFunding.min);

                    colorIndex = (delta * 1000).toFixed();

                    if (colorIndex > this.heatmap.color.length - 1) {
                        colorIndex = this.heatmap.color.length - 1;
                    }
                }
            } else {
                activeCode = this.activeStateCode;
                if (this.stateData[stateCode]) {
                    stateData = this.stateData[stateCode][this.mapPlotBy];
                    delta = (stateData - this.heatmap.funding.min) / (this.heatmap.funding.max - this.heatmap.funding.min);

                    colorIndex = (delta * 10).toFixed();

                    if (colorIndex > this.heatmap.color.length - 1) {
                        colorIndex = this.heatmap.color.length - 1;
                    }
                }
            }

            if (isNaN(colorIndex)) {
                colorIndex = this.heatmap.color.length - 1;
            }
            if (colorIndex) {
                fillColor = this.heatmap.color[colorIndex];
            }

            if (feature.getProperty('state') === 'hover' && activeCode !== stateCode) {
                strokeWeight = 2;
                strokeColor = '#FBA803';
                fillColor = '#FAECAF';
                fillOpacity = 0.85;
                zIndex = 3;
            }

            if (this.activeCongDist) {
                if (activeCode !== stateCode) {
                    fillOpacity = 0.75;
                    zIndex = 2;
                    fillColor = '#C1C1C1'
                    strokeColor = '#888';
                }
            }

            return {
                strokeWeight: strokeWeight,
                strokeColor: strokeColor,
                zIndex: zIndex,
                fillColor: fillColor,
                fillOpacity: fillOpacity,
                visible: show
            };
        },
        buildHeatmapUS (data) {
            this.geoJSON.heatmapUS = data;

            this.mapLayer.heatmapUS = new google.maps.Data();

            // set up bounds for each State for dynamic zoom levels
            this.mapLayer.heatmapUS.addListener('addfeature', (e) => {
                let bounds = new google.maps.LatLngBounds();

                e.feature.getGeometry().forEachLatLng(function (latlng) {
                    bounds.extend(latlng);
                });

                // save bounds
                e.feature.setProperty('bounds', bounds);
            });

            this.mapLayer.heatmapUS.addListener('click', this.clickState);
            this.mapLayer.heatmapUS.addListener('mouseover', this.tooltipStateShow);
            this.mapLayer.heatmapUS.addListener('mouseout', this.tooltipHide);
            this.mapLayer.heatmapUS.addListener('mousemove', this.tooltipUpdate);

            this.mapLayer.heatmapUS.addGeoJson(this.geoJSON.heatmapUS, { idPropertyName: 'ABVR' });

            this.redrawMap();
        },
        buildHeatmapState(data) {
          let mapDisplay = this.externalURLs['reporter_map_display'];
          if (mapDisplay === 'true') {
            if (this.heatmap.visible) {
              this.hideHeatmapUS();
            }
            var tempData = {
              features: [],
              type: data.type
            }
            if (data.features.length) {
              for (let i = 0; i < data.features.length; i++) {
                let congCode = data.features[i].properties.st + '-' + data.features[i].properties.CDId;
                if (this.congDistData && this.congDistData[congCode]) {
                  tempData.features.push(data.features[i]);
                }
              }
            }
            this.loadingMap = false;
            this.geoJSON.heatmapUSState = tempData;

            this.mapLayer.heatmapUSState = new google.maps.Data();

            // set up bounds for each State for dynamic zoom levels
            this.mapLayer.heatmapUSState.addListener('addfeature', (e) => {
              let bounds = new google.maps.LatLngBounds();

              e.feature.getGeometry().forEachLatLng(function (latlng) {
                bounds.extend(latlng);
              });

              // save bounds
              e.feature.setProperty('bounds', bounds);
            });

            this.mapLayer.heatmapUSState.addListener('click', this.clickCongDist);
            this.mapLayer.heatmapUSState.addListener('mouseover', this.tooltipStateShow);
            this.mapLayer.heatmapUSState.addListener('mouseout', this.tooltipHide);
            this.mapLayer.heatmapUSState.addListener('mousemove', this.tooltipUpdate);

            this.mapLayer.heatmapUSState.addGeoJson(this.geoJSON.heatmapUSState, { idPropertyName: 'CDId' });
            this.mapLayer.heatmapUSState.setMap(this.theMap);
            this.mapLayer.heatmapUSState.setStyle(this.styleHeatmapShape);
            this.mapLayer.heatmapUSState.zIndex = 102;
          }
        },
        updateMap () {
            this.clearMarkers();
            this.mapView = 'USState';
            if (this.mapLayer.heatmapUSState) {
                this.congDistData = null;
                toRaw(this.mapLayer.heatmapUSState).setMap(null);
            }
            this.getMapData(this.redrawMap);
        },
        updateMapData () {
            this.getNewMapData(this.redrawMap);
        },
        redrawMap () {
            this.tooltipHide();

            let selectedCountry = null;

            this.activeCountry = null;
            this.activeStateCode = null;
            this.activeCongDist = null;

            // if only one state exists in results, center on that state
            if (this.mapFilterData.states.length === 2) {
                this.activeStateCode = this.getStateName(this.mapFilterData.states[1], false);
                this.selectedStateCode = this.getStateName(this.mapFilterData.states[1], false);
                this.centerOnState(this.activeStateCode);
            } else {
                this.activeStateCode = this.selectedStateCode;
                if (this.mapFilterData.states.length === 1) {
                    this.centerOnState(this.activeStateCode);
                }
            }

            // if only one country is in results
            // center on that country and force selection in dropdown
            if ((this.mapFilterData.countries.length === 2 && this.mapFilterData.countries[1] !== this.USA) || (this.selectedCountry && this.selectedCountry !== this.USA && this.selectedCountry !== 'All')) {
                if (!this.selectedCountry) {
                    this.activeCountry = this.mapFilterData.countries[1];
                } else {
                    this.activeCountry = this.selectedCountry;
                }

                if (this.heatmap.visible) {
                    this.hideHeatmapUS();
                }

                if (!this.activeStateCode) {
                    this.centerOnCountry(this.activeCountry);
                }
            } else {
                if (this.heatmap.visible) {
                    this.updateHeatmapUS();
                } else {
                    this.showHeatmapUS();
                }

                if (!this.activeStateCode) {
                    this.centerOnCountry(this.USA);
                }
            }

            if (this.activeStateCode && this.stateData[this.activeStateCode]) {
                if (this.selectedStateCode) {
                    this.selectedCountry = this.USA;
                }
                setTimeout(() => {
                    this.getMapStateData([this.activeStateCode], this.addMapMarkers);
                }, 500);
            } else if (this.selectedCountry && this.selectedCountry !== 'All' && this.selectedCountry !== this.USA) {
                setTimeout(() => {
                    this.getMapCountryData([this.selectedCountry], this.addMapMarkers);
                }, 500);
            } else {
                this.selectedStateCode = null;
                this.activeStateCode = null;

                if (this.mapFilterData.countriesNotUS.length !== 0 && (!this.selectedCountry || this.selectedCountry === 'All')) {
                    setTimeout(() => {
                        this.getMapCountryData(this.mapFilterData.countriesNotUS, this.addMapMarkers);
                    }, 500);
                } else {
                    this.clearMarkers();

                    if (this.selectedCountry === this.USA) {
                        this.setupProjectAndFundingTotals(this.countryData[this.USA]);
                    }
                    this.loadingMap = false;
                }
            }
        },
        updateHeatmapUS () {
            if (this.mapLayer.heatmapUS) {
                this.mapLayer.heatmapUS.setStyle(this.styleHeatmapShape);
            }
        },
        showHeatmapUS() {
          let mapDisplay = this.externalURLs['reporter_map_display'];
          if (mapDisplay === 'true') {
            if (this.mapLayer.heatmapUS) {
              toRaw(this.mapLayer.heatmapUS).setMap(null);
            }
            this.heatmap.visible = true;

            setTimeout(() => {
              let heatMapUSLayer = toRaw(this.mapLayer.heatmapUS);
              heatMapUSLayer.setStyle(this.styleHeatmapShape);
              heatMapUSLayer.setMap(this.theMap);
              heatMapUSLayer.zIndex = 10;
            });
          }
        },
        hideHeatmapUS () {
            toRaw(this.mapLayer.heatmapUS).setMap(null);
            this.heatmap.visible = false;
        },
        tooltipStateShow (params) {
            if (params.domEvent && params.domEvent.srcElement && params.domEvent.srcElement.nodeName !== 'IMG') {
                let stateCode = params.feature.getProperty("ABVR"),
                    stateName = params.feature.getProperty("NAME"),
                    stateProjectsCount,
                    stateFundingAmount,
                    sAmt,
                    mousePos = {
                        x: params.domEvent ? params.domEvent.layerX : '',
                        y: params.domEvent ? params.domEvent.layerY : ''
                    };

                if (this.mapView === 'USState') {
                    if (this.selectedStateCode !== stateCode) {
                        if (this.stateData[stateCode]) {
                            stateProjectsCount = window.filters.addCommas(this.stateData[stateCode].projects_count);
                            sAmt = this.stateData[stateCode].projects_funding_amount;
                            stateFundingAmount = sAmt && parseInt(sAmt) > 0 ? window.filters.formatCurrency(sAmt) : '';

                            params.feature.setProperty('state', 'hover');

                            this.mapLayer.heatmapUS.setStyle(this.styleHeatmapShape);
                        } else {
                            stateProjectsCount = 'NA',
                                stateFundingAmount = 'NA'
                        }

                    }
                } else {
                    stateCode = params.feature.getProperty("CDId");
                    stateName = "Congressional District: " + this.selectedStateCode + '-' + stateCode;

                    if (this.congDistData && this.congDistData[this.selectedStateCode + '-' + stateCode]) {
                        stateProjectsCount = window.filters.addCommas(this.congDistData[this.selectedStateCode + '-' + stateCode].projects_count);
                        sAmt = this.congDistData[this.selectedStateCode + '-' + stateCode].projects_funding_amount;
                        stateFundingAmount = sAmt && parseInt(sAmt) > 0 ? window.filters.formatCurrency(sAmt) : '';

                        params.feature.setProperty('state', 'hover');

                        this.mapLayer.heatmapUS.setStyle(this.styleHeatmapShape);
                    } else {
                        stateProjectsCount = 'NA';
                        stateFundingAmount = 'NA'
                    }
                }

                this.tooltipSetPosition(mousePos);

                setTimeout(() => {
                    this.tooltipContent = '<strong>' + stateName + '</strong><br>' + 'Projects: ' + stateProjectsCount + '<br>Funding: ' + stateFundingAmount;
                }, 1);
            }
        },
        tooltipOrgShow (params) {
            this.tooltipSetPosition(params.mousePos);

            setTimeout(() => {
                this.tooltipContent = '<strong>' + params.orgName + '</strong><br>' + 'Projects: ' + params.projects + '<br>Funding: ' + params.funding;
            }, 1);
        },
        tooltipHide (params) {
            this.tooltipContent = null;

            if (params) {
                params.feature.setProperty('state', 'normal');
            }

        },
        tooltipSetPosition (mousePos) {
            let offset = {
                x: 20,
                y: 5
            };

            if (this.$refs.tooltip && mousePos.x && mousePos.y) {
                this.$refs.tooltip.style.top = (mousePos.y + offset.y) + 'px';
                this.$refs.tooltip.style.left = (mousePos.x + offset.x) + 'px';
            }
        },
        tooltipUpdate (params) {
            this.tooltipSetPosition(params);
        },
        clickState (params) {
            let stateCode = params.feature.getProperty("ABVR");

            if (this.stateData[stateCode]) {
                this.selectState(stateCode);
                this.activeMarkerIndex = null;
            }
        },
        clickCongDist (params) {
            let congDistCode = params.feature.getProperty("CDId");

            if (this.congDistData && this.congDistData[this.selectedStateCode + '-' + congDistCode]) {
                this.selectCongDist(this.selectedStateCode + '-' + congDistCode);
                this.activeMarkerIndex = null;
            }
        },
       centerOnState (stateCode) {
            let params = this.mapLayer.heatmapUS ? this.mapLayer.heatmapUS.getFeatureById(stateCode) : null;

            if (params) {
                // center view on State
                this.theMap.setCenter(params.getProperty("bounds").getCenter());
                // center zoom in based on State size
                this.theMap.fitBounds(params.getProperty("bounds"));
            } else {
                // look up for territories
                let StateName = this.getStateName(stateCode, true);
                if (StateName !== 'All') {
                    this.theMap.setCenter(this.countryCenter[StateName]);
                    this.theMap.setZoom(8);
                }
            }

            this.tooltipHide();
        },
        selectCongDist (congDistCode) {
            this.activeOrg = null;
            this.showUSStateMapIcon = false;
            this.clearMarkers();

            if (congDistCode && congDistCode !== 'All') {
                this.showUSStateMapIcon = true;
                this.selectedCongDist = congDistCode;
                this.activeCongDist = this.selectedCongDist;

                setTimeout(() => {
                    this.getMapCongDistData([congDistCode], this.addMapMarkers);
                }, 101);

                if (this.selectedCountry !== this.USA) {
                    this.selectedCountry = this.USA;
                }

                this.mapTable.offset = 0;
                this.$nextTick(() => {
                    if (this.showUSStateMapIcon && this.showWorldMapIcon) {
                        this.createStateImg();
                    }
                });
                this.getTableData();
                let mapDisplay = this.externalURLs['reporter_map_display'];
                if (mapDisplay === 'true') {
                  this.mapLayer.heatmapUSState.setStyle(this.styleHeatmapShape);
                }
            } else {
                this.selectState(this.selectedStateCode);
            }
        },
        createStateImg () {
            var geochart,
                mode,
                regn,
                st = this.selectedStateCode,
                states = [
                    ['State', 'Active'],
                    ['US-AL', 0],
                    ['US-AK', 0],
                    ['US-AZ', 0],
                    ['US-AR', 0],
                    ['US-CA', 0],
                    ['US-CO', 0],
                    ['US-CT', 0],
                    ['US-DE', 0],
                    ['US-DC', 0],
                    ['US-FL', 0],
                    ['US-GA', 0],
                    ['US-HI', 0],
                    ['US-ID', 0],
                    ['US-IL', 0],
                    ['US-IN', 0],
                    ['US-IA', 0],
                    ['US-KS', 0],
                    ['US-KY', 0],
                    ['US-LA', 0],
                    ['US-ME', 0],
                    ['US-MT', 0],
                    ['US-NE', 0],
                    ['US-NV', 0],
                    ['US-NH', 0],
                    ['US-NJ', 0],
                    ['US-NM', 0],
                    ['US-NY', 0],
                    ['US-NC', 0],
                    ['US-ND', 0],
                    ['US-OH', 0],
                    ['US-OK', 0],
                    ['US-OR', 0],
                    ['US-MD', 0],
                    ['US-MA', 0],
                    ['US-MI', 0],
                    ['US-MN', 0],
                    ['US-MS', 0],
                    ['US-MO', 0],
                    ['US-PA', 0],
                    ['US-RI', 0],
                    ['US-SC', 0],
                    ['US-SD', 0],
                    ['US-TN', 0],
                    ['US-TX', 0],
                    ['US-UT', 0],
                    ['US-VT', 0],
                    ['US-VA', 0],
                    ['US-WA', 0],
                    ['US-WV', 0],
                    ['US-WI', 0],

                    // territories
                    ['AS', 0],
                    ['GU', 0],
                    ['MP', 0],
                    ['PR', 0],
                    ['VI', 0],

                    //other countries to hide
                    ['CA', 0],
                    ['MX', 0],
                    ['RU', 0]

                ];

            if (this.terList.indexOf(st) !== -1) {
                mode = 'countries';
                regn = st;
            } else {
                mode = 'provinces';
                regn = 'US-' + st;
            }

            for (let i = 0; i < states.length; i++) {
                if (states[i][0] === regn) {
                    states[i][1] = 1;
                    break;
                }
            }

            this.$nextTick(() => {
                if (document.getElementById('state-name')) {
                    document.getElementById('state-name').innerText = this.getStateName(this.selectedStateCode, true);
                }
            }, 100);

            var data = new google.visualization.arrayToDataTable(states),
                size = document.querySelector('#stCircButton > button') ? document.querySelector('#stCircButton > button').clientHeight : 26,
                opts = {
                    region: regn,
                    resolution: mode,
                    width: size,
                    height: size,
                    colorAxis: { colors: ['#bacfe5', '#fff'] },
                    backgroundColor: '#bacfe5',
                    datalessRegionColor: '#bacfe5',
                    legend: 'none'
                };

            geochart = new google.visualization.GeoChart(document.getElementById('stateMapCircle'));
            geochart.draw(data, opts);
        },
        selectState (stateCode) {
            this.activeOrg = null;
            this.activeCongDist = null;
            this.selectedCongDist = null;
            this.congDistData = null;
            this.showWorldMapIcon = true;
            this.clearMarkers();
            if (this.mapLayer.heatmapUSState) {
                toRaw(this.mapLayer.heatmapUSState).setMap(null);
            }

            if (stateCode && stateCode !== 'All') {
                this.showUSMapIcon = true;
                this.selectedStateCode = stateCode;

                setTimeout(() => {
                    this.centerOnState(stateCode);
                });

                setTimeout(() => {
                    this.getMapStateData([stateCode], this.addMapMarkers);
                }, 500);
            } else {
                this.showUSMapIcon = false;
                this.showUSStateMapIcon = false;
                this.mapView = 'USState';
                this.selectedStateCode = null;
                this.clearMarkers();
                this.updateHeatmapUS();
                this.tooltipHide();
                this.setupProjectAndFundingTotals(this.countryData[this.USA]);                
                let mapDisplay = this.externalURLs['reporter_map_display'];
                if (mapDisplay === 'true') {
                  this.theMap.setCenter(this.countryCenter.US);
                  this.theMap.setZoom(4);
                  this.redrawMap();
                }
            }

            this.activeStateCode = this.selectedStateCode;

            if (this.selectedCountry !== this.USA) {
                this.selectedCountry = this.USA;
            }

            this.mapTable.offset = 0;
            this.getTableData();
        },
        selectCountry (countryName) {
            this.mapView = 'USState';
            if (this.mapLayer.heatmapUSState) {
                toRaw(this.mapLayer.heatmapUSState).setMap(null);
            }
            this.selectedCountry = countryName;
            this.selectedStateCode = null;
            this.selectedCongDist = null;
            this.congDistData = null;
            this.activeOrg = null;
            this.loadingMap = true;
            this.showWorldMapIcon = true;
            this.showUSMapIcon = false;
            this.showUSStateMapIcon = false;
            this.clearMarkers();

            if (!countryName || countryName === 'All') {
                this.setupProjectAndFundingTotals(this.mapData);
                this.showWorldMapIcon = false;
            }

            this.redrawMap();
            this.loadingMap = false;
            this.mapTable.offset = 0;
            this.getTableData();
        },
        centerOnCountry (countryName) {            
            if (!countryName) {
                countryName = this.USA;
            }
            if(this.theMap) {
                let center = this.countryCenter[countryName];
                this.theMap.setCenter(center);
                this.theMap.setZoom(4);
            }
        },
        addMapMarkers(markerData) {
          let mapDisplay = this.externalURLs['reporter_map_display'];
          if (mapDisplay === 'true') {
            if (!markerData) {
              markerData = this.orgData;
            }

            let animationTime = 1000 / markerData.length,
              isRetina = window.devicePixelRatio > 1,
              imgSuffix = isRetina ? '@2x' : '',
              markerImage,
              markerScale = 1, // 1-6
              markerActive = false,
              bounds = new google.maps.LatLngBounds();

            this.clearMarkers();
            this.markersWithoutLatLongCount = 0;
            markerData = _.orderBy(markerData, 'projects_count', ['asc']);

            setTimeout(() => {
              this.markerData.funding.min = 0;
              this.markerData.funding.max = 0;
              this.markerData.projects.min = 0;
              this.markerData.projects.max = 0;

              for (let i = 0; i < markerData.length; i++) {
                // fix case inconsistency from backend
                if (markerData[i].name) {
                  markerData[i].name = markerData[i].name.toUpperCase();
                }

                if (i === 0) {
                  this.markerData.projects.min = markerData[i].projects_count;
                  this.markerData.funding.min = markerData[i].projects_funding_amount;
                } else {
                  if (markerData[i].projects_count < this.markerData.projects.min) {
                    this.markerData.projects.min = markerData[i].projects_count;
                  }

                  if (markerData[i].projects_funding_amount < this.markerData.funding.min) {
                    this.markerData.funding.min = markerData[i].projects_funding_amount;
                  }
                }

                if (markerData[i].projects_count > this.markerData.projects.max) {
                  this.markerData.projects.max = markerData[i].projects_count;
                }

                if (markerData[i].projects_funding_amount > this.markerData.funding.max) {
                  this.markerData.funding.max = markerData[i].projects_funding_amount;
                }
              }

              for (let i = 0; i < markerData.length; i++) {
                if (markerData[i].geo_lat_lon) {
                  bounds.extend({
                    lat: markerData[i].geo_lat_lon.lat,
                    lng: markerData[i].geo_lat_lon.lon
                  });
                  setTimeout(() => {
                    let markAmtSize = Number(((markerData[i].projects_funding_amount / this.markerData.funding.max) * 5).toFixed()),
                      markerScale = (isNaN(markAmtSize) ? 0 : markAmtSize) + 1;

                    markerImage = {
                      url: '/img/map-marker-' + markerScale + imgSuffix + '.png',
                      size: new google.maps.Size(25, 30),
                      scaledSize: new google.maps.Size(25, 30),
                    };

                    this.mapMarkers[i] = new google.maps.Marker({
                      position: {
                        lat: markerData[i].geo_lat_lon.lat,
                        lng: markerData[i].geo_lat_lon.lon
                      },
                      map: this.theMap,
                      icon: markerImage,
                      animation: google.maps.Animation.DROP,
                      zIndex: 200,
                    });

                    google.maps.event.addListener(this.mapMarkers[i], 'mouseover', (event) => {
                      var keys = Object.keys(event),
                        pageX, pageY,
                        offset = window.offset(this.$refs.theMap),
                        mousePos;

                      for (var cnt = 0; cnt < keys.length; cnt++) {
                        if (MouseEvent.prototype.isPrototypeOf(event[keys[cnt]])) {
                          pageX = event[keys[cnt]].pageX;
                          pageY = event[keys[cnt]].pageY;
                          break;
                        }
                      }

                      mousePos = {
                        x: pageX - offset.left,
                        y: pageY - offset.top
                      };

                      this.tooltipOrgShow({
                        mousePos: mousePos,
                        orgName: markerData[i].name,
                        projects: markerData[i].projects_count,
                        funding: markerData[i].projects_funding_amount && markerData[i].projects_funding_amount > 0 ? window.filters.formatCurrency(markerData[i].projects_funding_amount) : ''
                      });
                    });

                    google.maps.event.addListener(this.mapMarkers[i], 'click', (event) => {
                      let markerImageActive = {
                        url: '/img/map-marker-' + markerScale + '-active' + imgSuffix + '.png',
                        size: this.mapMarkers[i].icon.size,
                        scaledSize: this.mapMarkers[i].icon.scaledSize,
                      },
                        markerImage;

                      // deactivate previously selected map marker
                      if (this.activeMarkerIndex !== null) {
                        markerImage = {
                          url: this.mapMarkers[this.activeMarkerIndex].icon.url.replace('-active', ''),
                          size: this.mapMarkers[this.activeMarkerIndex].icon.size,
                          scaledSize: this.mapMarkers[this.activeMarkerIndex].icon.scaledSize,
                        };
                        this.mapMarkers[this.activeMarkerIndex].setIcon(markerImage);
                      }

                      this.mapMarkers[i].setIcon(markerImageActive);

                      this.activeOrg = markerData[i].name;
                      this.activeMarkerIndex = i;
                      this.mapTable.offset = 0;
                      this.getTableData();
                    });

                  }, i * animationTime);
                } else {
                  this.markersWithoutLatLongCount++;
                }
              }

              if (this.countryData[this.USA] && this.countryData[this.USA].states.length > 0 && this.mapView === 'USState' && (this.selectedCountry === null || (this.selectedCountry && (this.selectedCountry.toLowerCase() === 'united states' || this.selectedCountry.toLowerCase() === 'all')))) {
                bounds.extend({
                  lat: this.countryCenter.US.lat,
                  lng: this.countryCenter.US.lng
                });
              }
              if (this.markersWithoutLatLongCount !== markerData.length) {
                this.theMap.fitBounds(bounds);
              }
              setTimeout(() => {
                this.loadingMap = false;
              }, 500);
            }, 1);
          }
        },
        clearMarkers () {
            for (let i = 0; i < this.mapMarkers.length; i++) {
                let markerObj = toRaw(this.mapMarkers[i]);
                if (markerObj) {
                    markerObj.setMap(null);
                }
            }

            this.mapMarkers = [];
        },
        goBack () {
            var self = this;

            if (self.$refs.drillDownTable) {
                self.$refs.drillDownTable.table.loadingMoreData = false;
            }
            self.loadSlide = false;
        },
        resetMapFilters () {
            this.selectedCountry = 'All';
            this.selectedStateCode = null;
            this.selectedCongDist = null;
            this.activeOrg = null;
            this.mapTable.offset = 0;
            this.showWorldMapIcon = false;
            this.showUSMapIcon = false;
            this.showUSStateMapIcon = false;
            this.clearMarkers();
            this.centerOnCountry();

            if (this.heatmap.visible) {
                this.hideHeatmapUS();
            }
        },
        getTableData (updateTableData) {
            let criteriaCopy = copyData(this.searchCriteria);
            let filterByFacets = copyData(this.searchFacetCriteria);

            this.loadingGraphData = updateTableData ? false : true;
            criteriaCopy.exclude_subprojects = true;

            if (this.selectedCountry && this.selectedCountry && this.selectedCountry !== 'All') {
                filterByFacets.countries = [];
                filterByFacets.countries.push(this.selectedCountry);
            }

            if (this.selectedStateCode && this.selectedStateCode !== 'All') {
                filterByFacets.states = [];
                filterByFacets.states.push(this.selectedStateCode);
            }

            if (this.selectedCongDist && this.selectedCongDist !== 'All') {
                filterByFacets.cong_dists = [];
                filterByFacets.cong_dists.push(this.selectedCongDist);
            }

            if (this.activeOrg) {
                filterByFacets.org_names = [];
                filterByFacets.org_names.push(this.activeOrg);
            }

            if (this.selectedPerson) {
                if (this.selectedPerson.role === 'pi') {
                    criteriaCopy['pi_profile_ids'] = this.selectedPerson.profile_id;
                } else if (this.selectedPerson.role === 'po') {
                    criteriaCopy['po_names'] = this.selectedPerson.name;
                }
            }
            var parsedCriteria = window.parseCriteria(criteriaCopy, { isSubmitForm: false }),
                criteria = window.stringifySearchCriteriaFields(parsedCriteria),
                searchParam = {
                    search_id: this.$route.params.search_id,
                    offset: this.mapTable.offset || 0,
                    limit: this.mapTable.limit || 50,
                    facet_filters: filterByFacets,
                    criteria: criteria,
                };

            if (this.mapTable.sortField) {
                searchParam.sort_field = this.mapTable.sortField;
                searchParam.sort_order = this.mapTable.sortOrder
            }

            if (updateTableData) {
                window.getSearchResults(searchParam, this.updateTableResults);
            } else {
                window.getSearchResults(searchParam, this.handleTableResults);
            }
        },
        handleTableResults (data) {
            if (data && data.results) {
                this.setGraphData(data);

                this.$nextTick(() => {
                    this.initWindowEvents();
                    if (this.$refs && this.$refs.dataTable) {
                        this.$refs.dataTable.initTableData();
                    }
                    this.mapTable.isLoading = false;
                    this.loadingGraphData = false;
                });
            } else {
                this.mapTable.isLoading = false;
                this.loadingGraphData = false;
            }
                
            this.$nextTick();
            setTimeout(() => {
                if (document.querySelector("#scrollTable")) {
                    document.querySelector("#scrollTable").removeAttribute("style");
                }
                bus.$emit('update:resize');
            }, 501);
        },
        updateTableResults (data) {
            var self = this;

            this.updateGraphData(data);
            this.mapTable.isLoading = false;
            this.mapTable.loadingMoreData = false;

            this.$nextTick(() => {
                self.$refs.dataTable.initTableData();
                self.loadingGraphData = false;
            });
            setTimeout(() => {
                bus.$emit('update:resize');
            }, 101);
        },
        setProjectPageNumber (requestedPage) {
            if (this.$store.state.graphData && requestedPage === this.pageName) {
                if (this.$store.state.graphData.meta.total > this.mapTable.offset + this.mapTable.limit) {
                    this.mapTable.loadingMoreData = true;
                    this.mapTable.offset += this.mapTable.limit;
                    this.getTableData(true);
                }
            }
        },
        getNewMapData (callback) {
            var searchParam = {
                facet_filters: this.$parent.searchFacetCriteria,
                criteria: this.getNewSearchCriteria(true),
                view_by: 'HeatMap',
                map_filters: {
                    states: [],
                    countries: [],
                    cong_dists: []
                }
            };

            this.loadingMap = true;

            window.getMapData(searchParam, this.parseMapData, callback);
        },
        getMapData (callback) {
            var searchParam = {
                search_id: this.$route.params.search_id,
                facet_filters: this.$parent.searchFacetCriteria,
                map_filters: {
                    states: [],
                    countries: [],
                    cong_dists: []
                }
            };

            this.loadingMap = true;

           let mapDisplay = this.externalURLs['reporter_map_display'];
           if (mapDisplay === 'true') {
             window.getMapData(searchParam, this.parseMapData, callback);
           } else {
            window.getMapData(searchParam, this.parseMapData, null);
           }
        },
        setupProjectAndFundingTotals (data) {
            this.totalProjects = 0;
            this.totalFunding = 0;

            if (data.projects_count && data.projects_funding_amount) {
                this.totalProjects += data.projects_count;
                this.totalFunding += data.projects_funding_amount;
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].projects_count) {
                        this.totalProjects += data[i].projects_count;
                    }

                    if (data[i].projects_funding_amount) {
                        this.totalFunding += data[i].projects_funding_amount;
                    }
                }
            }

        },
        parseMapData (data, callback) {
            if (data && data.meta) {
                this.setSearchMeta(data.meta);

                this.updateURLSearchId(data.meta.search_id, 'projects/map');
            }

            if (data && data.results) {
                this.mapData = data.results;

                this.countryData = {};
                this.stateData = {};

                this.heatmap.funding.min = 0;
                this.heatmap.funding.max = 0;

                // build dictionary of Countries
                for (let i = 0; i < this.mapData.length; i++) {
                    let countryName = this.mapData[i].name;

                    this.countryData[countryName] = this.mapData[i];
                }

                // build dictionary of US States
                if (this.countryData[this.USA]) {
                    for (let i = 0; i < this.countryData[this.USA].states.length; i++) {
                        let stateCode = this.countryData[this.USA].states[i].code,
                            stateData = this.countryData[this.USA].states[i][this.mapPlotBy];

                        if (i === 0) {
                            this.heatmap.funding.min = stateData;
                        } else {
                            if (stateData < this.heatmap.funding.min) {
                                this.heatmap.funding.min = stateData;
                            }
                        }

                        if (stateData > this.heatmap.funding.max) {
                            this.heatmap.funding.max = stateData;
                        }

                        this.stateData[stateCode] = this.countryData[this.USA].states[i];
                    }
                }

                this.setupProjectAndFundingTotals(this.mapData);
                this.setupMapFilterData();
                if (callback) {
                  callback();
                } else if (this.selectedStateCode === null) {
                  this.congDistData = null;
                } else if (this.selectedStateCode && this.stateData[this.selectedStateCode]) {                                        
                    if (this.selectedStateCode) {
                        this.selectedCountry = this.USA;
                     }
                    this.getMapStateData([this.selectedStateCode], {});                    
                }
            }
        },
        getMapCountryData (countries, callback) {
            var searchParam = {
                search_id: this.$route.params.search_id,
                facet_filters: this.$parent.searchFacetCriteria,
                map_filters: {
                    states: [],
                    countries: countries,
                    cong_dists: []
                }
            };

            window.getMapData(searchParam, this.parseMapCountryData, callback, 'DataByCountry');
        },
        getMapCongDistData (congDistCode, callback) {
            var searchParam = {
                search_id: this.$route.params.search_id,
                facet_filters: this.$parent.searchFacetCriteria,
                map_filters: {
                    states: [],
                    countries: [],
                    cong_dists: congDistCode
                }
            };

            this.loadingMap = true;
            window.getMapData(searchParam, this.parseMapCountyData, callback, 'DataByCongDists');
        },
        getMapStateData (states, callback) {
            var searchParam = {
                search_id: this.$route.params.search_id,
                facet_filters: this.$parent.searchFacetCriteria,
                map_filters: {
                    states: states,
                    countries: [],
                    cong_dists: []
                }
            };

            this.loadingMap = true;
            window.getMapData(searchParam, this.parseMapStateData, callback, 'DataByState');
        },
        parseMapCountryData (data, callback) {
            let countries = data.results,
                countryName,
                organizations;

            this.orgData = [];

            for (let i = 0; i < countries.length; i++) {
                countryName = countries[i].name;
                organizations = countries[i].organizations;

                if (organizations) {
                    for (let i2 = 0; i2 < organizations.length; i2++) {
                        // if lat/lng is 0,0 set to center of country
                        // otherwise it will plot in the center of the map
                        if ((!organizations[i2].geo_lat_lon || (organizations[i2].geo_lat_lon.lat === 0 && organizations[i2].geo_lat_lon.lon === 0)) && this.countryCenter[countryName]) {
                            if (!organizations[i2].geo_lat_lon) {
                                organizations[i2].geo_lat_lon = {};
                            }

                            organizations[i2].geo_lat_lon.lat = this.countryCenter[countryName].lat;
                            organizations[i2].geo_lat_lon.lon = this.countryCenter[countryName].lng;
                        }

                        this.orgData.push(organizations[i2]);
                    }
                }
            }

            if (this.selectedCountry && this.selectedCountry !== this.USA && this.selectedCountry !== 'All') {
                this.setupProjectAndFundingTotals(this.orgData);
            }

            if (callback) {
                callback();
            }
        },
        parseMapStateData (data, callback) {
            if (data && data.results) {
                let tempCongData = _.filter(data.results, row => row.name === this.selectedStateCode);
                let mapCongDistData = tempCongData && tempCongData.length > 0 ? tempCongData[0] : data.results[0];

                this.congDistData = {};

                this.heatmap.congDistFunding.min = 0;
                this.heatmap.congDistFunding.max = 0;

                // build congressional district dictionary of US States
                if (this.countryData[this.USA]) {
                    for (let i = 0; i < mapCongDistData.cong_dists.length; i++) {
                        let congDistCode = mapCongDistData.cong_dists[i].code,
                            congDistData = mapCongDistData.cong_dists[i][this.mapPlotBy];

                        if (i === 0) {
                            this.heatmap.congDistFunding.min = congDistData;
                        } else {
                            if (congDistData < this.heatmap.congDistFunding.min) {
                                this.heatmap.congDistFunding.min = congDistData;
                            }
                        }

                        if (congDistData > this.heatmap.congDistFunding.max) {
                            this.heatmap.congDistFunding.max = congDistData;
                        }

                        this.congDistData[congDistCode] = mapCongDistData.cong_dists[i];
                    }
                }

                if (this.selectedStateCode && this.selectedStateCode !== 'All') {
                    this.getUSHeatmapShapeData(this.buildHeatmapState);
                }
                this.setupProjectAndFundingTotals(mapCongDistData);
                this.setupMapFilterData();
            }
        },
        parseMapCountyData (data, callback) {
            if (data && data.results) {
                let mapCongDistData = data.results[0],
                    stateName = this.selectedStateCode;

                this.orgData = [];

                if (mapCongDistData.organizations) {
                    this.orgData = copyData(mapCongDistData.organizations);
                }
                this.setupProjectAndFundingTotals(this.orgData);
            }
            if (callback) {
                callback();
            }
            this.loadingMap = false;
        },
        parseMapOrgData (data, callback) {
            this.orgData = data.results;

            if (this.selectedCountry && this.selectedCountry !== 'All') {
                for (let i = 0; i < this.orgData.length; i++) {
                    if (this.orgData[i].geo_lat_lon && this.orgData[i].geo_lat_lon.lat === 0 && this.orgData[i].geo_lat_lon.lon === 0) {
                        this.orgData[i].geo_lat_lon.lat = this.countryCenter[this.selectedCountry].lat;
                        this.orgData[i].geo_lat_lon.lon = this.countryCenter[this.selectedCountry].lng;
                    }
                }

                this.setupProjectAndFundingTotals(this.orgData);
            }


            if (callback) {
                callback();
            }
        },
        formatter (value, axis) {
            if (this.plotBy === 'funding') {
                return window.filters.formatLargeCurrency(value);
            } else {
                return window.filters.addCommas(value);
            }
        },
        setSortDetails ($event, selectedSortColumn) {
            this.isLoading = true;
            var selectedSortField = this.getFieldNameFromSettings(selectedSortColumn);

            if (this.mapTable.sortField === selectedSortField) {
                this.mapTable.sortOrder = (this.mapTable.sortOrder === 'asc' ? 'desc' : 'asc');
            } else {
                this.mapTable.sortOrder = selectedSortColumn.sortOrder;
            }
            this.mapTable.sortField = selectedSortField;
            this.mapTable.offset = 0;

            this.getTableData();
            window.scrollTo(0, document.getElementsByClassName('tableContainer')[0].offsetTop);
			gtag('event', 'Click', {
				'event_category': 'Map - Sorting',
				'event_label': 'Map table - ' + selectedSortColumn.fieldName + ' - ' + this.mapTable.sortOrder,
				'value': 'Map table - ' + selectedSortColumn.fieldName + ' - ' + this.mapTable.sortOrder
			});	
        },
    }
}
</script>


<style lang="scss">
@import '@/scss/variables.scss';
@import '@/scss/charts.scss';
@import 'node_modules/bootstrap/scss/_functions';
@import 'node_modules/bootstrap/scss/_variables';
@import '@/scss/variables.scss';
@import 'node_modules/bootstrap/scss/_mixins';

.chart-menu {

    .dropdown-menu {
        max-height: 300px;
        overflow-y: auto;
        width: 100%;
    }
}

.BDropdown {
    .dropdown-toggle {
        text-align: left;

        &:after {
            margin-top: 10px;
            float: right;
        }

        &:hover,
        &:focus,
        &:active {
            @include button-variant($blue-light, $blue-light);
        }
    }

    &.show {
        .btn-light {
            @include button-variant($blue-light, $blue-light);
        }
    }
}
</style>
<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/charts.scss';

.dropdown-toggle {
    text-align: left;
}

#map-navs {
    position: relative;
    z-index: 1000;
    display: block;

    #mapbar,
    #stmapbar {
        width: 3px;
        height: 28px;
        background-color: #027dc4;
        position: absolute;
        right: 34px;
        top: 64px;
        z-index: 1;
        display: block;
    }

    #stmapbar {
        top: 128px;
    }

    #globe-box,
    #state-box,
    #heatmap-box {
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 10;

        &.heat-map {
            top: 88px;
            right: 0px;
            background-color: transparent !important;
            border: 0;
            box-shadow: none !important;
            text-align: right !important;
            display: block;

        }

        .heatmap-circle {
            $states-bg: #bacfe5;

            border-radius: 50% 50%;
            background-color: #fff;
            height: 40px;
            width: 40px;
            display: inline-block;
            border: 3px solid #027dc4;
            vertical-align: middle;
            position: relative;
            box-shadow: 0 1px 6px rgba(0, 0, 0, 0.33);

            button {
                border-radius: 50% 50%;
                background: $states-bg;
                width: 26px;
                height: 26px;
                left: 4px;
                top: 4px;
                position: absolute;
                border: 0;
                padding: 0;
                outline: none;
                border: none;

                .badge {
                    background-color: #3977bb;
                    font-weight: normal;
                    font-size: 14px;
                    padding: 3px 10px 4px;
                    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.33);
                    position: absolute;
                    right: 100%;
                    margin-right: 14px;
                    top: 3px;
                    display: none;
                    color: #fff;
                    border-radius: 15px;
                }
            }

            &:hover {
                border-color: #1c5297;

                button {
                    background-color: darken($states-bg, 8%);
                }

                .badge {
                    display: block;
                }
            }
        }
    }

    #globe-box {
        display: block;

        &.heat-map {
            top: 5px;
            right: 5px;

            .globe {

                width: 64px;
                height: 64px;


                button {
                    width: 50px;
                    height: 50px;
                }
            }

            .btn-state {

                width: 18px;
                height: 18px;


                button {
                    width: 16px;
                    height: 16px;
                }
            }
        }

        .heatmap-circle {
            button {
                .badge {
                    top: 16px;
                }
            }
        }
    }

    #heatmap-box,
    #state-box {
        margin-right: 15px;
    }

    #state-box {
        display: block;

        &.heat-map {
            top: 148px;
            right: 0;
        }

        &.solo {
            top: 10px;
        }
    }

    #heatmap-box {
        img {
            margin-top: 1px;
            width: 24px;
        }

        &.solo {
            top: 10px;
            margin-right: 10px;

            ~#stmapbar {
                top: 48px;
                right: 29px;
            }

            ~#state-box {
                margin-right: 10px;
                top: 70px;
            }
        }
    }

    #stateMapCircle {
        pointer-events: none;
        border-radius: 50%;
        overflow: hidden;
        display: block;

        svg>g>g:nth-child(3) {
            display: none;
        }

        path {
            stroke: rgba(178, 200, 224, 0);
            stroke-width: 0.5px;
        }

    }
}

.map-container {
    position: relative;
}

.table-header {
    padding: 10px 5px;
    font-size: 15px;
    border-top: 5px solid #fff;

    .label {
        font-weight: bold;
    }
}

.map {
    width: 100%;
    height: 60vh;
    background-color: #fff;
}

.chartDataTable {
    .chart-container {
        z-index: 20; // set to put map dropdowns above floated table headers
    }

    .visualization-menu {
        &:after {
            position: absolute;
            content: "";
            top: 100%;
            left: 0;
            width: 100%;
            height: 6px;
            z-index: 10;
            background: transparent;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 100%);
        }

        .chart-menu {
            width: auto;
            vertical-align: text-top;

            &.chart-menu-country {
                width: 230px;
            }

            &.chart-menu-state {
                width: 230px;
            }
        }

        .chart-header-value {
            color: $blue;
            font-weight: 700;
            font-size: 18px;
            line-height: 1em;
        }
    }
}

.no-data {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: rgba(253, 168, 8, 0.26);
    margin: auto;
    width: 100%;
    padding: 0.5em 12px;
    font-weight: 700;
    color: #000000;
}
</style>
